<template>
  <div class="visor container is-fluid">
    <div class="columns">
      <page-header title="Cierre de Pedido"></page-header>
    </div>
    <b-loading v-model="cargando" :is-full-page="true" :can-cancel="false" />
    <div v-if="pedidoExiste && !cargando" class="detalle-pedido">
      <cierre-cabecera :pedido="pedidoPadre" />
      <cierre-detalle />
    </div>
    <div v-else class="detalle-pedido notification is-info">
      El pedido no est&aacute; disponible para generar despacho en MOPI!
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import PageHeader from '@/components/shared/PageHeader.vue'
import CierreCabecera from '@/components/cierre/CierreCabecera.vue'
import CierreDetalle from '@/components/cierre/CierreDetalle.vue'

export default {
  name: 'CierrePedido',
  components: {
    PageHeader,
    CierreCabecera,
    CierreDetalle
  },
  computed: {
    ...mapGetters('despacho', ['pedidoExiste', 'pedidoPadre', 'cargando']),
    ...mapGetters('sesion', ['bodega'])
  },
  created() {
    const id = this.$route.params.id
    if (id) {
      this.buscarPedido({
        tipoDocumento: 'I',
        numeroDocumento: id,
        bodegaId: this.bodega.id
      })
    }
  },
  methods: {
    async buscarPedido(payload) {
      await this.$store.dispatch('despacho/setPedido', payload)
    }
  }
}
</script>
